import { Tag, TagColorType } from "components/DesignSystem/Tag/Tag";
import { TaskRelatedFile } from "./TaskRelatedFile";
import { FormStatusWithFiles } from "types/Models/TaskTracker";
import { ConditionalLink } from "components/conditionalLink";

type TaskStatusOption = {
  color: TagColorType;
  text: string;
};

export const NOT_LAUNCHED = "NOT_LAUNCHED";
export const NOT_STARTED = "NOT_STARTED";

export const taskStatusOptions: Record<string, TaskStatusOption> = {
  ADD_DETAILS: {
    color: "orange",
    text: "Add Details",
  },
  INKLE_PRICING: {
    color: "orange",
    text: "Inkle Pricing",
  },
  IN_PROGRESS: {
    color: "blue",
    text: "In Progress",
  },
  COMPLETED: {
    color: "green",
    text: "Completed",
  },
  AMENDMENT_FILED: {
    color: "orange",
    text: "Task Amendment",
  },
  AMENDMENT: {
    color: "orange",
    text: "Task Amendment",
  },
  TASK_AMENDMENT_COMPLETED: {
    color: "green",
    text: "Task Amendment Completed",
  },
  NOT_STARTED: {
    color: "orange",
    text: "Not Started",
  },
  NOT_LAUNCHED: {
    color: "orange",
    text: "Not Launched",
  },
  UNPAID: {
    color: "red",
    text: "Unpaid",
  },
  AWAITING_FROM_ADP: {
    color: "red",
    text: "Awaiting from ADP",
  },
  AWAITING_FROM_CUSTOMER: {
    color: "red",
    text: "Awaiting from customer",
  },
};

export const TaskStatusWithFiles = ({
  taskList,
  groupId,
  taskId,
}: {
  taskList: FormStatusWithFiles | null;
  groupId: string;
  taskId?: string;
}) => {
  if (
    !taskList ||
    !taskList.status ||
    taskList.status === NOT_LAUNCHED ||
    taskList.status === NOT_STARTED
  ) {
    return "-";
  }

  const selectedStatus = taskStatusOptions[taskList.status];

  if (!selectedStatus) {
    return "-";
  }

  return (
    <div
      className="t-flex t-justify-between t-items-center t-pr-2"
      onClick={(e) => e.stopPropagation()}
    >
      {taskId ? (
        <ConditionalLink to={`/tax/filings/${taskId}`} key={taskId}>
          <Tag icon={false} tagType={selectedStatus?.color} rounded>
            {selectedStatus?.text}
          </Tag>
        </ConditionalLink>
      ) : (
        <Tag icon={false} tagType={selectedStatus?.color} rounded>
          {selectedStatus?.text}
        </Tag>
      )}

      <div className="t-flex t-gap-1">
        {taskList.task_documents?.map((document) => (
          <TaskRelatedFile
            fileId={document.uuid}
            fileType={document.file_type}
            key={document.uuid}
            groupId={groupId}
          />
        ))}
      </div>
    </div>
  );
};
